import { render, staticRenderFns } from "./ListTutorials.vue?vue&type=template&id=5b1f9a4d"
import script from "./ListTutorials.vue?vue&type=script&lang=js"
export * from "./ListTutorials.vue?vue&type=script&lang=js"
import style0 from "./ListTutorials.vue?vue&type=style&index=0&id=5b1f9a4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports